"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _group = _interopRequireDefault(require("./_group.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
var _default = exports.default = (0, _group.default)(function (result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true);